import React from "react";

export const Footer = () => {
  return (
    <div className="footer">
      <p>
        <strong>
          <span>By</span> Kevin Peter
        </strong>
      </p>
      <div className="socials">
        <a href="https://github.com/Kevzpeter" className="fa fa-github p-2" aria-hidden="true">
          {" "}
        </a>
        <a href="mailto:kevzpeterk@gmail.com" className="fa fa-paper-plane p-2" aria-hidden="true">
          {" "}
        </a>
        <a href="https://kevzpeter.com" className="fas fa-home p-2" aria-hidden="true">
          {" "}
        </a>
      </div>
    </div>
  );
};
